<template>
  <router-view />
</template>

<script>
export default {
  name: "publicity"
};
</script>